module.exports = __webpack_public_path__ + "static/4th-dev-ffbe028e2bddec327e2edae2abf0b956.jpg";